export default {
  SettingBaseDataRegion: {
    newProvincial: '新增',
    msgWarning: '返回数据为空，请联系管理员',

    table: {
      code: '区域编码',
      name: '区域名称',
      abbreviation: '简称',
      subordinateArea: '新建下级区域',
    },

    addAndEdit: {
      addTitle: '新建行政区定义',
      editTitle: '编辑行政区定义',
      code: '地区编码',
      name: '地区名称',
      abbreviation: '简称',
      superiorArea: '上级地区',
      countryCodeText: '请输入国家编码',
      countryNameText: '请输入国家名称',

    }
  }
};
